export default __webpack_public_path__ + "static/media/O-011.a3b0fe3e.png";